<template>
    <Shell :transition="transition">
        <template #header>
            <div>
                <button class="flex items-center space-x-1 text-sm hover:underline" @click="voltar()">
                    <svg class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                        <path
                            fill-rule="evenodd"
                            d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                            clip-rule="evenodd"
                        />
                    </svg>
                    <span>{{ __('Voltar') }}</span>
                </button>
            </div>
        </template>

        <div class="p-4 space-y-4 flex-grow overflow-auto">
            <div class="bg-white rounded shadow p-2">
                <div v-if="selectedQuestion" data-teclia-trix-attachment="on">
                    <div class="font-bold">{{ selectedQuestion.título }}</div>
                    <div v-html="selectedQuestion.corpo_html"></div>
                </div>
            </div>
        </div>
    </Shell>
</template>

<script>
import Shell from './Shell.vue'

export default {
    props: ['transition'],
    components: { Shell },
    computed: {
        selectedQuestion() {
            if (this.$store.state.selectedQuestionId && this.$store.state.questionsFoundFromKnowledgeDatabaseSearch) {
                let questions = this.$store.state.questionsFoundFromKnowledgeDatabaseSearch || []

                if (questions && questions.data && Array.isArray(questions.data)) {
                    questions = questions.data
                }

                return questions.find((q) => {
                    return q.id == this.$store.state.selectedQuestionId
                })
            }

            return null
        },
    },
    methods: {
        voltar() {
            this.$store.commit('selectQuestion', null)
            this.$store.dispatch('transiçãoParaEsquerda', 'search')
        },
    },
}
</script>